import { render, staticRenderFns } from "./ListImportantNews.vue?vue&type=template&id=0e9310da&"
import script from "./ListImportantNews.vue?vue&type=script&lang=js&"
export * from "./ListImportantNews.vue?vue&type=script&lang=js&"
import style0 from "./ListImportantNews.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Tag: require('/home/runner/work/myody_front/myody_front/components/tag/Tag.vue').default,TagList: require('/home/runner/work/myody_front/myody_front/components/tag/TagList.vue').default,Link: require('/home/runner/work/myody_front/myody_front/components/link/Link.vue').default,Card: require('/home/runner/work/myody_front/myody_front/components/card/Card.vue').default})
